import { render, staticRenderFns } from "./OpenForm.vue?vue&type=template&id=4f91e2e5&"
import script from "./OpenForm.vue?vue&type=script&lang=js&"
export * from "./OpenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports